import { styled } from 'styled-components';
export const PageInfoWrapper = styled.div `
  position: relative;
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.grey100_1};
`;
